// Duration Magnitudes, in seconds.
export const second = 1;
export const minute: number = 60 * second;
export const hour: number = 60 * minute;
export const day: number = 24 * hour;
export const week: number = 7 * day;
export const year: number = 365 * day;
export const month: number = year / 12;
